// Shared by the master and participant views so both compute the same
// number — only meaningful for numeric decks (fibonacci/confidence); '?'
// and '☕' just get filtered out since they're not a number.
export const averageVotes = (participants) => {
  const numbers = participants
    .filter((p) => p.vote !== null)
    .map((p) => Number(p.vote))
    .filter((n) => !Number.isNaN(n))
  if (numbers.length === 0) return null
  const sum = numbers.reduce((total, n) => total + n, 0)
  return Math.round((sum / numbers.length) * 10) / 10
}
